import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { showErrorSnackbar } from 'components/shared/Snackbar';
import { getPlannerTasks } from 'RestAPIs/planner-messages';
import { getContentRange } from 'components/employee-portal/messages/utilts';
import { PlannerMessage } from '../types';
import {
  TAB_TASK_KEY_MAP,
  PAGE_SIZE,
  TASK_QUERY_CACHE_TIME
} from '../constants';
import { usePlannerMessagesStore } from '../store';

type PlannerTasksResponse = [PlannerMessage[], number];

const useGetPlannerTasks = () => {
  const { tab, status, startDate, endDate, costCenterIds, pageIndex } =
    usePlannerMessagesStore();

  const rangeStart = pageIndex * PAGE_SIZE;
  const rangeEnd = rangeStart + PAGE_SIZE - 1;

  return useQuery<PlannerTasksResponse, AxiosError>({
    queryKey: [
      'plannerTasks',
      tab,
      status,
      startDate,
      endDate,
      costCenterIds,
      pageIndex
    ],
    queryFn: async () => {
      const response = await getPlannerTasks({
        collection: status,
        taskDefinitionKeys: TAB_TASK_KEY_MAP[tab]
          ? [...TAB_TASK_KEY_MAP[tab]!]
          : undefined,
        costCenterIds: costCenterIds.length ? costCenterIds : undefined,
        startDate: startDate || undefined,
        endDate: endDate || undefined,
        range: `items=${rangeStart}-${rangeEnd}`
      });

      const contentRangeHeader = response.headers['content-range'];
      const totalCount = contentRangeHeader
        ? getContentRange(contentRangeHeader)[2]
        : response.data.length;

      return [response.data, totalCount];
    },
    onError: (error: AxiosError) => {
      showErrorSnackbar(error.message);
    },
    keepPreviousData: true,
    cacheTime: TASK_QUERY_CACHE_TIME
  });
};

export default useGetPlannerTasks;
